module.exports = __webpack_public_path__ + "static/media/01_welcome-ID.e3fcbd93.gif";